/**
 * @generated SignedSource<<30244b3487b2a0e6c314ede30801f647>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HomePanelGroupEllipsis_RenameGroupMutation$variables = {
  emoji?: string | null;
  groupId: string;
  name: string;
};
export type HomePanelGroupEllipsis_RenameGroupMutation$data = {
  readonly editGroup: {
    readonly group: {
      readonly emojiName: string | null;
      readonly id: string;
      readonly name: string;
    } | null;
  } | null;
};
export type HomePanelGroupEllipsis_RenameGroupMutation = {
  response: HomePanelGroupEllipsis_RenameGroupMutation$data;
  variables: HomePanelGroupEllipsis_RenameGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emoji"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "emoji",
        "variableName": "emoji"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "groupId"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "EditGroupMutation",
    "kind": "LinkedField",
    "name": "editGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HomePanelGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emojiName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePanelGroupEllipsis_RenameGroupMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomePanelGroupEllipsis_RenameGroupMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2cf0b2110c64421209be6dc44fa1076f",
    "id": null,
    "metadata": {},
    "name": "HomePanelGroupEllipsis_RenameGroupMutation",
    "operationKind": "mutation",
    "text": "mutation HomePanelGroupEllipsis_RenameGroupMutation(\n  $groupId: ID!\n  $name: String!\n  $emoji: String\n) {\n  editGroup(id: $groupId, name: $name, emoji: $emoji) {\n    group {\n      id\n      name\n      emojiName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7860f57a7ece9330e70db4f2d472ca1";

export default node;
